var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { info, confirm } from '../../../core/components/Confirm';
const LAST_MODERATOR_ERROR_CODE = 400317;
const ONLY_ONE_MODERATOR_ERROR_CODE = 400318;
const lastModeratorModal = () => info({
    title: React.createElement(FormattedMessage, { id: "community.leaveCommunityTitle" }),
    content: React.createElement(FormattedMessage, { id: "community.leaveCommunityBodyLastMember" }),
    okText: React.createElement(FormattedMessage, { id: "community.leaveCommunityButtonOK" }),
});
const onlyOneModeratorModal = () => info({
    title: React.createElement(FormattedMessage, { id: "community.leaveCommunityTitle" }),
    content: React.createElement(FormattedMessage, { id: "community.leaveCommunityBodyOnlyModerator" }),
    okText: React.createElement(FormattedMessage, { id: "community.leaveCommunityButtonOK" }),
});
function onClickLeaveCommunityOk(communityId, leaveCommunity) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield leaveCommunity(communityId);
        }
        catch (error) {
            // Member > 0, moderator === 1
            if (error.code === LAST_MODERATOR_ERROR_CODE) {
                onlyOneModeratorModal();
            }
            // Member === 1, moderator === 1
            if (error.code === ONLY_ONE_MODERATOR_ERROR_CODE) {
                lastModeratorModal();
            }
        }
    });
}
export const leaveCommunityConfirmModal = (communityId, leaveCommunityFunc) => confirm({
    'data-qa-anchor': 'leave-community',
    title: React.createElement(FormattedMessage, { id: "community.leaveCommunityTitle" }),
    content: React.createElement(FormattedMessage, { id: "community.leaveCommunityBody" }),
    okText: React.createElement(FormattedMessage, { id: "community.leaveCommunityButtonText" }),
    onOk: () => onClickLeaveCommunityOk(communityId, leaveCommunityFunc),
});
//# sourceMappingURL=leaveScenarioModals.js.map